import type { FaireProductEntity } from "../../entity_types/product";

export const p_upzrfhmg7r: FaireProductEntity = {
  token: "p_upzrfhmg7r",
  type: "product",
  name: "Mahjong Crossbody Clutch Bag - Handmade in USA",
  brandToken: "b_62353496",
  brandName: "Kent Stetson Handbags",
  imageUrl:
    "https://cdn.faire.com/fastly/765ea8f573c749f873baa1ab01940cf90c710a03d1eb679b6a584fc20f14b870.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/18c95eb1117f8917f84e72507b7d311be1ca1c604e411c865b49d8db7433dc7d.jpeg",
    "https://cdn.faire.com/fastly/a5c03c9bc764dc2d06c17d5a8de544438196f1f86324276147902f1d264004d2.jpeg",
    "https://cdn.faire.com/fastly/2f7a9fe5fca68b221571c29408553d6e2f6881bfdd87f2aa69b0d7a73a652f0b.jpeg",
  ],
  priceDollars: 79.04,
  description:
    "Gorgeous asymmetrical clutch featuring a playful Mahjong set. Features 3D attachment. Cruelty-free, made from luxury quality coated canvas. All bags come with a removable cross-body chain, logo dust bag, clear vinyl inner pocket, and are individually signed. Inside fabric may differ from what is pictured. Inside fabric may differ from what is pictured. Price includes shipping. \n\n * Material: Coated Canvas \n * Dimensions: 12 x 7 x 1 \n * Proudly handmade in the USA. \n * Individually signed by the Artist. \n\n\n",
  tags: [],
  msrpDollars: 208,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:42.716Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
